export default "__VITE_ASSET__CNGbc$zz__"